import {
  ACCESS_VERIFY,
  FETCH_USERS,
  FETCH_USER,
  CREATE_USER,
  TOGGLE_USER_STATUS,
  UPDATE_USER,
  DELETE_USER,
  GET_CURRENT_USER,
  ATTACH_AVATAR,
  FETCH_USER_LOGINS,
  FETCH_ALL_ACCESS_REQUESTS,
  APPROVE_ACCESS_REQUEST,
  REJECT_ACCESS_REQUEST,
  ON_APPROVE_ACCESS_REQUEST,
  ON_RECEIVE_ACCESS_REQUEST,
  ON_REJECT_ACCESS_REQUEST
} from "../actions";
import { NotificationManager } from "react-notifications";
import ls from "local-storage";

const initialState = {
  newUser: null,
  selectedUser: null,
  users: null,
  statusUser: null,
  updatedUser: null,
  currentUser: null,
  deletedUser: null,
  newAvatar: null,
  loading: false,
  error: null,
  userLogins: null,
  selectedUserError: null,
  usersError: null,
  newUserError: null,
  statusUserError: null,
  updatedUserError: null,
  userLoginsError: null,
  currentUserError: null,
  newAvatarError: null,
  adminAuthorized: false,
  verifyAccessKey: ls.get("access_key"),
  verifyAccessStatus: "",
  verifyAccessError: "",
  accessRequests: [],
  fetchAccessRequestsError: "",
  approveAccessRequestError: "",
  deleteUserError: ""
};

function userReducer(state = initialState, action) {
  let newUser,
    selectedUser,
    users,
    statusUser,
    deletedUser,
    updatedUser,
    currentUser,
    userLogins,
    newAvatar,
    verifyAccessKey,
    verifyAccessStatus,
    verifyAccessError,
    accessRequests,
    fetchAccessRequestsError,
    approveAccessRequestError,
    rejectAccessRequestError,
    deleteUserError;

  switch (action.type) {
    //PENDING
    case `${FETCH_USER}_PENDING`:
    case `${FETCH_USERS}_PENDING`:
    case `${CREATE_USER}_PENDING`:
    case `${DELETE_USER}_PENDING`:
    case `${TOGGLE_USER_STATUS}_PENDING`:
    case `${UPDATE_USER}_PENDING`:
    case `${ATTACH_AVATAR}_PENDING`:
    case `${FETCH_USER_LOGINS}_PENDING`:
    case `${GET_CURRENT_USER}_PENDING`:
    case `${ACCESS_VERIFY}_PENDING`:
    case `${FETCH_ALL_ACCESS_REQUESTS}_PENDING`:
    case `${APPROVE_ACCESS_REQUEST}_PENDING`:
    case `${REJECT_ACCESS_REQUEST}_PENDING`:
      return { ...state, loading: true };
    case `${FETCH_USER}_FULFILLED`:
      selectedUser = action.payload.data;
      return { ...state, loading: false, selectedUser };

    case `${FETCH_USERS}_FULFILLED`:
      users = action.payload.data;
      return { ...state, loading: false, users: users };

    case `${CREATE_USER}_FULFILLED`:
      newUser = action.payload.data;
      return { ...state, loading: false, newUser };

    case `${DELETE_USER}_FULFILLED`:
      deletedUser = action.payload.data;
      return { ...state, loading: false, deletedUser };

    case `${TOGGLE_USER_STATUS}_FULFILLED`:
      statusUser = action.payload.data;
      return { ...state, loading: false, statusUser };

    case `${UPDATE_USER}_FULFILLED`:
      updatedUser = action.payload.data;
      return { ...state, loading: false, updatedUser };

    case `${FETCH_USER_LOGINS}_FULFILLED`:
      userLogins = action.payload.data;
      return { ...state, loading: false, userLogins };

    case `${GET_CURRENT_USER}_FULFILLED`:
      currentUser = action.payload.data;
      if (!currentUser) {
        NotificationManager.error(
          "You don't have an account associated with this pet shop"
        );
      }
      return { ...state, loading: false, currentUser };

    case `${ATTACH_AVATAR}_FULFILLED`:
      newAvatar = action.payload.data;
      return { ...state, loading: false, newAvatar };

    case `${ACCESS_VERIFY}_FULFILLED`:
      verifyAccessStatus = action.payload.data.message;
      return {
        ...state,
        loading: false,
        verifyAccessStatus: verifyAccessStatus
      };

    case `${FETCH_ALL_ACCESS_REQUESTS}_FULFILLED`:
      accessRequests = [...action.payload.data];
      return {
        ...state,
        loading: false,
        accessRequests: accessRequests
      };

    case `${APPROVE_ACCESS_REQUEST}_FULFILLED`:
      NotificationManager.success(action.payload.data.message);
      accessRequests = [...state.accessRequests];
      accessRequests.splice(
        state.accessRequests.findIndex(item => {
          return item._id === action.payload.data.id;
        }),
        1
      );
      return {
        ...state,
        loading: false,
        accessRequests: accessRequests
      };
    case `${REJECT_ACCESS_REQUEST}_FULFILLED`:
      NotificationManager.warning(action.payload.data.message);
      accessRequests = [...state.accessRequests];
      accessRequests.splice(
        state.accessRequests.findIndex(item => {
          return item._id === action.payload.data.id;
        }),
        1
      );
      return {
        ...state,
        loading: false,
        accessRequests: accessRequests
      };
    //REJECTED
    case `${FETCH_ALL_ACCESS_REQUESTS}_REJECTED`:
      fetchAccessRequestsError = `${action.payload.message}`;
      NotificationManager.error(action.payload.message);
      return {
        ...state,
        loading: false,
        fetchAccessRequestsError: fetchAccessRequestsError
      };
    case `${ACCESS_VERIFY}_REJECTED`:
      verifyAccessError = `${action.payload.message}`;
      NotificationManager.error(action.payload.message);
      return {
        ...state,
        loading: false,
        verifyAccessError: verifyAccessError
      };
    case `${APPROVE_ACCESS_REQUEST}_REJECTED`:
      approveAccessRequestError = `${action.payload.message}`;
      NotificationManager.error(action.payload.message);
      return {
        ...state,
        loading: false,
        approveAccessRequestError: approveAccessRequestError
      };
    case `${REJECT_ACCESS_REQUEST}_REJECTED`:
      rejectAccessRequestError = `${action.payload.message}`;
      NotificationManager.error(action.payload.message);

      return {
        ...state,
        loading: false,
        rejectAccessRequestError: rejectAccessRequestError
      };
    case `${FETCH_USER}_REJECTED`:
      return {
        ...state,
        loading: false,
        selectedUserError: `${action.payload.message}`
      };
    case `${FETCH_USERS}_REJECTED`:
      return {
        ...state,
        loading: false,
        usersError: `${action.payload.message}`
      };
    case `${CREATE_USER}_REJECTED`:
      return {
        ...state,
        loading: false,
        newUserError: `${action.payload.message}`
      };
    case `${TOGGLE_USER_STATUS}_REJECTED`:
      return {
        ...state,
        loading: false,
        statusUserError: `${action.payload.message}`
      };
    case `${UPDATE_USER}_REJECTED`:
      return {
        ...state,
        loading: false,
        updatedUserError: `${action.payload.message}`
      };
    case `${DELETE_USER}_REJECTED`:
      return {
        ...state,
        loading: false,
        deleteUserError: `${action.payload.message}`
      };
    case `${GET_CURRENT_USER}_REJECTED`:
      return {
        ...state,
        loading: false,
        currentUserError: `${action.payload.message}`
      };
    case `${ATTACH_AVATAR}_REJECTED`:
      return {
        ...state,
        loading: false,
        newAvatarError: `${action.payload.message}`
      };
    case `${FETCH_USER_LOGINS}_REJECTED`:
      return {
        ...state,
        loading: false,
        userLoginsError: `${action.payload.message}`
      };
    //SOCKETS
    case `${ON_APPROVE_ACCESS_REQUEST}`:
      ls.set("access_key", action.payload.data.access_key, () => {
        verifyAccessKey = action.payload.data.access_key;
      });
      verifyAccessStatus = action.payload.message;
      return {
        ...state,
        loading: false,
        verifyAccessKey: verifyAccessKey,
        verifyAccessStatus: verifyAccessStatus
      };
    case `${ON_REJECT_ACCESS_REQUEST}`:
      ls.remove("access_key", () => {
        verifyAccessKey = null;
      });
      verifyAccessStatus = action.payload.message;
      return {
        ...state,
        loading: false,
        verifyAccessKey: verifyAccessKey,
        verifyAccessStatus: verifyAccessStatus
      };
    case `${ON_RECEIVE_ACCESS_REQUEST}`:
      accessRequests = [action.payload.data, ...state.accessRequests];
      return {
        ...state,
        loading: false,
        accessRequests: accessRequests
      };
    default:
      return state;
  }
}

export default userReducer;
